<app-navbar></app-navbar>
<div class="container-fluid layout">
  <router-outlet></router-outlet>            
</div>